import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import { PlusOutlined } from '@ant-design/icons'
import CheckInput from '@components/LocalMerchant/SetMealCreate/CheckInput'
import 'antd4/lib/grid/style/index.css'
import { Button, MagicInput } from 'hljd'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import DoubleInput from './DoubleInput'
import getFormDetail from './FormDetail'
import InputInterval from './InputInterval'
import RadioInput from './RadioInput'
import SelectInput from './SelectInput'
import style from './style.module.less'
import TravelStroke from './TravelStroke'

const Item = Form.Item
@Form.create({
  onValuesChange(props, value, allValues) {
    const [field] = Object.keys(value)
    const args = field.split('-')
    if (args.length == 2 && args[1] == 'id') {
      // 处理radioInput的点击
      delete allValues[args[0] + '-title']
    }
    if (args.length == 3 && args[2] == 'id' && !value[field]) {
      // 处理selectInput的删除一条数据
      const pre = `${args[0]}-${args[1]}-`
      delete allValues[pre + 'id']
      delete allValues[pre + 'extra']
    }
    if (args.length == 3 && args[2] == 'title' && !value[field]) {
      // 处理doubleInput的删除一条数据
      const pre = `${args[0]}-${args[1]}-`
      delete allValues[pre + 'title']
      delete allValues[pre + 'extra']
    }
    props.store.submitForm(allValues)
  }
})
@observer
export default class extends Component {
  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.store.submitForm(values)
      }
    })
  }

  componentDidMount() {
    this.props.store.form = this.props.form
    this.sessionScrollWrapper = document.querySelector('#sessionScrollWrapper')
    this.sessionScrollWrapper.addEventListener('scroll', this.onScroll)
  }

  componentWillUnmount = () => {
    this.sessionScrollWrapper.removeEventListener('scroll', this.onScroll)
  }

  onScroll = () => {
    this.serviceEditor.style.top =
      this.sessionScrollWrapper.scrollTop + 88 + 'px'
  }

  // 添加行程
  handleAddTravel = () => {
    this.props.store.handleAddItinerary()
  }

  render() {
    const {
      service,
      handleChangeDisabledItem,
      handleOptionHidden,
      handleChangeDisabledOption,
      handleChangeDataNode,
      sourceServiceConfig
    } = this.props.store
    const activeService = service.find(el => el.status)
    const activeSourceService = sourceServiceConfig.find(
      f => f?.key === activeService?.key
    )
    const { getFieldDecorator, setFieldsValue } = this.props.form
    return activeService ? (
      <div
        className={style.content}
        id="setMeal-service-edit"
        ref={ref => (this.serviceEditor = ref)}
      >
        <div className={style.editorBar}>
          <p className={style.editorTitle}>{activeService.text}</p>
        </div>
        <div className={style.editorCenter} id="setMeal-service-edit-scroll">
          <Form layout="vertical" className={style.form}>
            {activeService.childNodes.map((el, index) => {
              // toJS转换对应的初始值类型
              const {
                text,
                type,
                key,
                fontLimit,
                value,
                required,
                placeholder,
                disabled,
                unit,
                unitOptions,
                unitKey
              } = toJS(el)
              switch (type) {
                case 'radio':
                case 'checkBox':
                case 'select':
                case 'inputNumber':
                case 'precisionInput':
                  return disabled ? null : (
                    <>
                      <Item label={text} key={key}>
                        {getFieldDecorator(key, {
                          initialValue:
                            value !== undefined && value !== null
                              ? type == 'checkBox'
                                ? value
                                : value + ''
                              : undefined,
                          rules: [
                            {
                              required,
                              message: `${text}信息未填写`
                            }
                          ]
                        })(
                          getFormDetail(
                            el,
                            this.props.form,
                            handleChangeDisabledItem,
                            handleOptionHidden,
                            handleChangeDisabledOption,
                            handleChangeDataNode,
                            this.props.store
                          )
                        )}
                      </Item>
                      {unitOptions && (
                        <Item label={''} key={unitKey}>
                          {getFieldDecorator(unitKey, {
                            initialValue: unit
                          })(<span />)}
                        </Item>
                      )}
                    </>
                  )
                case 'input':
                  return disabled ? null : (
                    <Item label={text} key={key}>
                      {getFieldDecorator(key, {
                        initialValue: value,
                        rules: [{ required, message: `${text}信息未填写` }]
                      })(
                        <CheckInput
                          inputChange={value => {
                            setFieldsValue({ [key]: value })
                          }}
                        >
                          <MagicInput
                            maxLength={fontLimit}
                            placeholder={placeholder}
                            showCount
                            countPosition="inner"
                            style={{
                              marginRight: 10
                            }}
                            showWarning={false}
                          />
                        </CheckInput>
                      )}
                    </Item>
                  )
                case 'inputInterval':
                  return (
                    <InputInterval
                      form={this.props.form}
                      key={key}
                      index={index}
                      data={el}
                      store={this.props.store}
                    />
                  )
                case 'textArea':
                  return disabled ? null : (
                    <Item label={text} key={key}>
                      {getFieldDecorator(key, {
                        initialValue: value,
                        rules: [{ required, message: `${text}信息未填写` }]
                      })(
                        <CheckInput
                          inputChange={value => {
                            setFieldsValue({ [key]: value })
                          }}
                        >
                          <MagicInput.TextArea
                            maxLength={fontLimit}
                            placeholder={placeholder}
                            showCount
                            rows={10}
                            showWarning={false}
                          />
                        </CheckInput>
                      )}
                    </Item>
                  )
                case 'radioInput':
                  return disabled ? null : (
                    <RadioInput
                      form={this.props.form}
                      key={key}
                      index={index}
                      data={el}
                      sourceService={activeSourceService}
                      store={this.props.store}
                    />
                  )
                case 'selectInput':
                  return (
                    <SelectInput
                      form={this.props.form}
                      key={key}
                      index={index}
                      data={el}
                      store={this.props.store}
                    />
                  )
                case 'doubleInput':
                  return (
                    <DoubleInput
                      form={this.props.form}
                      key={key}
                      index={index}
                      data={el}
                      store={this.props.store}
                    />
                  )
                case 'lvpai_itinerary':
                  return <TravelStroke key={key} />

                default:
                  return null
              }
            })}
          </Form>
        </div>
        {activeService.key === 'itinerary_level' && (
          <div className={style.addTravel}>
            <Button
              onClick={this.handleAddTravel}
              ghost
              type="primary"
              icon={<PlusOutlined />}
            >
              添加行程
            </Button>
          </div>
        )}
      </div>
    ) : null
  }
}
